import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table, FormControl } from 'react-bootstrap';
import { getCourse, getRegisFees, PostRegisFees, updateRegistrationFees } from "../../../api/registrationfees";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function RegistrationFees() {
    const [selectedCourse, setSelectedCourse] = useState([]);
    const [courses, setCourses] = useState([]);
    const [fetchedRegistrationFees, setFetchedRegistrationFees] = useState([]);
    const [registrationFeesInput, setRegistrationFeesInput] = useState("");
    const [error, setError] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [isActive, setIsActive] = useState(true);
    const [errors, setErrors] = useState({});
    const handleActiveChange = (e) => setIsActive(e.target.checked);
    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [courseResponse, registrationresp] = await Promise.all([
                    getCourse(token),
                    getRegisFees(token)
                ]);
                setCourses(courseResponse.data);
                console.log("Courses:", courseResponse.data);
                setFetchedRegistrationFees(registrationresp.data);
                console.log("registration:", registrationresp.data);

            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);

    const handleCourseChange = (e) => {
        const courseId = e.target.value;
        setSelectedCourse((prevSelected) =>
            prevSelected.includes(courseId)
                ? prevSelected.filter((id) => id !== courseId) 
                : [...prevSelected, courseId]
        );
        setErrors((prev) => ({ ...prev, selectedCourse: "" }));
    };

    const handleRegistrationFeesChange = (e) => {
        const value = e.target.value
        setRegistrationFeesInput(value); 
        if (value.trim()) {
            const FeesError = validateRegistrationfee(value);
            setErrors(prev => ({
                ...prev,
                registrationFeesInput: FeesError
            }));
        } else {
            setErrors(prev => ({ ...prev, registrationFeesInput: "" }));
        }
    };

    const validateRegistrationfee = (value) => {
        if (!/^\d+$/.test(value)) {
            return "Only numbers are allowed.";
        }
        return "";
    };

    const handleSubmit = async () => {
        try {
            const newErrors = {};
            if (selectedCourse.length === 0) {
                newErrors.selectedCourse = "Please select at least one course.";
            }
            if (!registrationFeesInput) {
                newErrors.registrationFeesInput = "Please enter an registration fee.";
            } else {
                const FeesError = validateRegistrationfee(registrationFeesInput);
                if (FeesError) newErrors.registrationFeesInput = FeesError;
            }

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const isDuplicate = selectedCourse.some((id) =>
                fetchedRegistrationFees.some(
                    (reg) => String(reg.course?.id) === String(id)
                )
            );

            if (isDuplicate && !isEditing) {
                toast.error("Registration fee already exists for selected course.");
                return;
            }


            const request = isEditing
                ? {
                    courseId: selectedCourse[0], 
                    fees: registrationFeesInput,
                    active: isActive,
                }
                : {
                    courseIds: selectedCourse, 
                    fees: registrationFeesInput,
                    active: isActive,
                };
            console.log(request)

            if (isEditing) {
                await updateRegistrationFees(request, token);
                toast.success("Registration fee updated successfully!");
            } else {
                await PostRegisFees(request, token);
                toast.success("Registration fee added successfully!");
            }
            const response = await getRegisFees(token);
            setFetchedRegistrationFees(response.data);
            handleCancel();
        } catch (error) {
            console.error("Error submitting data:", error);
            toast.error("Failed to submit data.");
        }
    };

    const handleEdit = (registration) => {
        console.log("Edit data..:", registration);
        setSelectedCourse(
            registration.course ? [String(registration.course.id)] : []
        );
        setRegistrationFeesInput(registration.fees);
        setIsActive(registration.active);
        setIsEditing(true);
        console.log(selectedCourse);
        setEditingId(selectedCourse);
    };

    const handleCancel = () => {
        setEditingId(null);
        setSelectedCourse([]);
        setRegistrationFeesInput("");
        setIsActive(true);
        setIsEditing(false);
        setErrors({});
    };

    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Registration Fees</p>
                        <Form>
                            <Row className='mt-4'>
                                <Col>
                                    <Row className="mb-3">

                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Course<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">

                                            <DropdownButton
                                                title={
                                                    selectedCourse.length > 0
                                                        ? courses
                                                            .filter((course) => selectedCourse.includes(String(course.id)))
                                                            .map((course) => course.courseName)
                                                            .join(", ")
                                                        : "Select Course"
                                                }
                                                id="course-dropdown"
                                                className="course-dropdown"
                                            >
                                                <div style={{ padding: "10px" }}>
                                                    {courses.map((course) => (
                                                        <Form.Check
                                                            key={course.id}
                                                            type="checkbox"
                                                            id={`course-${course.id}`}
                                                            value={course.id}
                                                            label={course.courseName}
                                                            checked={selectedCourse.includes(String(course.id))}
                                                            onChange={handleCourseChange}
                                                        />
                                                    ))}
                                                </div>
                                            </DropdownButton>
                                            {errors.selectedCourse && (
                                                <div
                                                    style={{
                                                        color: "red",
                                                        fontSize: "13px",
                                                        marginTop: "3px",
                                                    }}
                                                >
                                                    {errors.selectedCourse}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Registration Fees<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                placeholder="Enter Registration Fees"
                                                id=" RegistrationFees"
                                                value={registrationFeesInput}
                                                onChange={handleRegistrationFeesChange}
                                                required />
                                            {errors.registrationFeesInput && (
                                                <div
                                                    style={{
                                                        color: "red",
                                                        fontSize: "13px",
                                                        marginTop: "3px",
                                                    }}
                                                >
                                                    {errors.registrationFeesInput}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label form-label">
                                            Active
                                        </Form.Label>
                                        <Col className="mt-2">
                                            <Form.Check
                                                type="switch"
                                                id="active"
                                                label="Check If Active"
                                                checked={isActive}
                                                onChange={handleActiveChange}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col></Col>
                            </Row>

                            <Row>
                                <Col className="d-flex align-items-center justify-content-center mb-3">
                                    <Button variant="primary" type="button" onClick={handleSubmit}>
                                        {isEditing ? "Update" : "Submit"}
                                    </Button>
                                    <ToastContainer />
                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>

                            <Row>
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Course</th>
                                            <th>Registration Fees</th>
                                            <th>Is Active</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(fetchedRegistrationFees) &&
                                            fetchedRegistrationFees.map((registration, index) => (
                                                <tr key={index}>
                                                    <td style={{ textAlign: "center" }}>
                                                        <Button variant="secondary" size="mb-3" type="button"
                                                            onClick={() => handleEdit(registration)}
                                                        >
                                                            <i className="bi bi-pencil-fill me-2" />
                                                            Edit
                                                        </Button>
                                                    </td>
                                                    <td>{registration.course?.courseName}</td>
                                                    <td>{registration.fees}</td>
                                                    <td>{registration.active ? 'Yes' : 'No'}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </Table>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>


        </>
    );
}

export default RegistrationFees;